import axios from 'axios'

export default {
    namespaced: true,
    state: {
        roles: []
    },
    getters: {
        GET_SELECT_FOR_STAFF(state) {
            return state.roles.filter(item => item.id === 6 || item.id === 8)
        }
    },
    mutations: {
        CLEAR_DATA(state) {
            state.roles = []
        },
        FETCH_ROLES(state, roles) {
            state.roles = roles
        }
    },
    actions: {
        fetch({commit, dispatch, state}) {
            return new Promise((resolve, reject) => {
                if (state.roles.length) {
                    resolve(state.roles)
                } else {
                    axios.get(
                        '/api/mixins/roles/list'
                    ).then(({data}) => {
                        commit('FETCH_ROLES', data.data)
                        resolve(data.data)
                    }).catch((error) => {
                        dispatch('checkUnauthenticated', error, { root: true })
                        reject(error)
                    })
                }
            })
        },
        clear({commit}) {
            commit('CLEAR_DATA')
        }
    }
}

